import React from 'react';
import ReactDOM from 'react-dom';

import { Toast } from 'src/app/components/Toast/Toast';
import { InjectedToastProps } from 'src/app/models/toast';

export function withToast(): <C>(WrappedComponent: C) => C {
  function wrappedComponent<C>(WrappedComponent: C): C;
  function wrappedComponent<P extends InjectedToastProps>(WrappedComponent: React.ComponentType<P>): React.ComponentClass<Pick<P, Exclude<keyof P, keyof InjectedToastProps>>> {
    type MyProps = P;
    const MAX_TOAST_ITEM = 4;

    interface MyState {
      toastContainer: {
        formattedMessageId: string;
        formattedMessageValue?: {};
      }[];
    }

    return class MyClassWithToast extends React.Component<MyProps, MyState> {
      constructor(props: MyProps) {
        super(props);

        this.state = {
          toastContainer: []
        };
        this.showToast = this.showToast.bind(this);
        this.closeToast = this.closeToast.bind(this);
      }

      render(): JSX.Element {
        return (
          <>
            {typeof window !== 'undefined' && ReactDOM.createPortal(
              this.renderAllToast(), this.getToastPortalDOM()
            )}
            <WrappedComponent {...this.props} showToast={this.showToast} />
          </>
        );
      }

      private renderAllToast(): JSX.Element[] {
        return this.state.toastContainer.map((item, index) => {
          return <Toast key={index} formattedMessageId={item.formattedMessageId} formattedMessageValue={item.formattedMessageValue} toastEndCallback={this.closeToast} />;
        });
      }

      private showToast(message: string, messageValue?: {}): void {
        this.setState({
          toastContainer: [...this.state.toastContainer.slice(1 - MAX_TOAST_ITEM), { formattedMessageId: message, formattedMessageValue: messageValue }]
        });
      }

      private closeToast(): void {
        this.state.toastContainer.shift();
        this.setState({
          toastContainer: this.state.toastContainer
        });
      }

      private getToastPortalDOM(): HTMLElement {
        const element = document.createElement('div');
        element.id = 'ktv-toast-container';
        element.className = 'd-flex position-fixed toast-container fld-column w-100';
        element.style.bottom = '16px';
        element.style.zIndex = '2300';
        return document.getElementById('ktv-toast-container') ?? document.body.appendChild(element);
      }
    };
  }

  return wrappedComponent;
}
